import react from "react";
import "./index.css";

export default function Patient() {
  return (
    <div className="header p-8 pb-0 border-solid border-neutral-300 border-2 rounded-md mb-8">
      <div className="flex flex-col ">
        <div className="patient pb-8">
          <img
            className="p-1 w-20 h-20 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
            src="https://i.postimg.cc/05cMGBfX/alfredo.jpg"
            alt="Bordered avatar"
          ></img>
          <div className="flex flex-col pl-2.5">
            <h1 className="text-3xl font-bold name1">Alferdo</h1>
            <h3 className="text-xl">Nurse</h3>
          </div>
        </div>
        <div className="patient pb-8">
          <img
            className="p-1 w-20 h-20 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
            src="https://i.postimg.cc/fTRd6Nyh/juan.jpg"
            alt="Bordered avatar"
          ></img>
          <div className="flex flex-col pl-2.5">
            <h1 className="text-3xl font-bold name1">Juan</h1>
            <h3 className="text-xl">Doctor</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
